import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import SelectMenuItem from "../Customer/Component/SelectMenuItem";
import { useUpdateCustomerMutation } from "../../../Service/customers";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerList } from "../../../store/async-actions/digitalmarketing/dashboard";
import { useGetDashboardCustomersQuery } from "../../../Service/dashboard";
import { ServiceChosen } from "../Customer/Utils/CustomerLabelInput";
import facebook from "../../../assets/DigitalMarketing/image/source/Fb.png";
import whatsapp from "../../../assets/DigitalMarketing/image/source/Whatsapp.png";
import x from "../../../assets/DigitalMarketing/image/source/x.png";
import insta from "../../../assets/DigitalMarketing/image/source/insta.png";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";

import yt from "../../../assets/DigitalMarketing/image/source/YT.png";
import linkedin from "../../../assets/DigitalMarketing/image/source/linkedin.png";
import google from "../../../assets/DigitalMarketing/image/source/g.png";
import walkin from "../../../assets/DigitalMarketing/image/source/walk-in.png";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import { useDeletePotentialLeadMutation } from "../../../Service/PotentialLeads";
import { formatDate } from "./Utils/TableHeadlist";

const useStyles = makeStyles({
  Mimo: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FB6A6A",
      backgroundColor: "#FFF7F7",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Fertility: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BB54A",
      backgroundColor: "#F7FFF8",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Action: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  status: {
    width: 148,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
});
interface props {
  potential_lead: any;
  getComparator: any;
  order: any;
  orderBy: string;
  
  stableSort: any;
  refetch:any;

}
function TableList({
  potential_lead,
  getComparator,
  order,
  orderBy,
  stableSort,
  refetch
}: props) {

 
  const [deletePotentialLead] = useDeletePotentialLeadMutation();

  const account = useSelector((state: any) => state.auth);

  
  const { open, message, openDelete, deleteId } = useDeleteBox();

  

  
  const Delete = async (bool) => {
    if (bool) {
      await deletePotentialLead(deleteId);
      refetch();
    }
    openDelete(
      "Are you sure you want to delete this appointment?",
      false,
      null
    );
  };
 
 
  return (
    <>
    <>        <AlertDialog open={open} message={message} deleteBranches={Delete} />
    </>
      {potential_lead?.map((a, i) => {
        return (
          <TableRow
            hover
            className="cursur"
            role="checkbox"
            tabIndex={-1}
            key={i}
          >  
            <TableCell align="left">{a.name}</TableCell>
            <TableCell align="left">{a.mobileNumber}</TableCell>
            <TableCell align="left">{a.source}</TableCell>

            <TableCell align="left">{a.status}</TableCell>
            <TableCell align="left">{formatDate(a.createdAt)}</TableCell>
            <TableCell align="left">
             
           
                <img
                  src={dele}
                  onClick={() =>
                    openDelete(
                      "Are you sure you want to delete this appointment?",
                      true,
                      a.id
                    )
                  }
                  className="delete-icon cursur action-icon"
                />
              
            </TableCell>


       
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
